import React from 'react'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles';
import ViewDetails from './ViewDetails';

const useStyles = makeStyles({
    root: { 
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800',
        alignItems: 'middle'
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '10px',
        textAlign: 'center'
    },

    body :{
        display: 'inline-block', 
        margin: '5px 20px 5px -10px', 
        
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '0',
        fontSize: '12px',
        textAlign: 'left'
    },
    p: {
        fontSize: '12px',
    },
    printButton: {
        backgroundColor: '#3f51b5',
        "&:hover": {
            backgroundColor: 'navy'
        },
        textAlign: 'center', 
        verticallAign: 'middle',
        borderRadius: '10px',
        color: 'white',
        fontWeight: 'bold',
        float: 'left',
        width: '6em',
       
    }
})

class ChecklistPrint extends React.Component {

    constructor(props){
      super(props)
    }
    
  
   render(props) {
    const record= this.props.record
    const classes = this.props.classes
    
   
    return(
        <div className={classes.root}>
            <div className={classes.title}>
                <p className={classes.p}>Training and Education Procedures</p>
                <h3>{(record && record.name)}</h3>
                <p className={classes.p}>Printed on {moment(Date()).format('MM/DD/yyyy')}</p>
            </div>

            <div className={classes.body}> 
           
                <table width="100%" >
                    <tbody>
                        <tr>
                            <td width="20%">Trainee:</td><td width="30%">{(record && record.trainee)}</td>
                            <td width="20%">Location:</td><td width="30%">{(record && record.location)}</td>
                        </tr>
                        <tr>
                            <td width="20%">Trainer 1:</td><td width="30%">{(record && record.trainer1)}</td>
                            <td width="20%">Initial:</td><td width="30%">{(record && record.trainer1_init)}</td>
                        </tr>
                        <tr>
                            <td width="20%">Trainer 2:</td><td width="30%">{(record && record.trainer2)}</td>
                            <td width="20%">Initial:</td><td width="30%">{(record && record.trainer2_init)}</td>
                        </tr>
                        <tr>
                            <td width="20%">Trainer 3:</td><td width="30%">{(record && record.trainer3)}</td>
                            <td width="20%">Initial:</td><td width="30%">{(record && record.trainer3_init)}</td>
                        </tr>
                        <tr><td  colSpan="4">&nbsp;</td></tr>
                    <tr>
                        <td colSpan="4">
                            <table border="1" cellSpacing="0" cellPadding="2" style={{ width:"100%"}}>
                                <tbody>
                                    <tr>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"25%", textAlign: "center"}}>Procedure</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"35%", textAlign: "center"}}>Reference</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Introduce</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainer Initial</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"8%", textAlign: "center"}}>Trainee Initial</th>
                                        <th style={{backgroundColor: "silver", fontWeight: "bold", width:"12%", textAlign: "center"}}>Date Proficient</th>
                                    </tr>      
                                    <ViewDetails records={record} ftype='content1' />                          
                                    {(record && record.sub_heading) && <tr>
                                        <td colSpan="6" style={{backgroundColor: "silver", fontWeight: "bold", textAlign: "center"}}>
                                            <h4>{(record && record.sub_heading)}</h4>
                                        </td>
                                    </tr>}
                                    <ViewDetails records={record} ftype='content2' />  
                                </tbody>
                            </table>
                    
                        </td>
                    </tr>
                    <tr><td  colSpan="4">&nbsp;</td></tr>
                    <tr>
                        <td  colSpan="4">
                            <table style={{width: "100%"}}>
                                <tbody>
                                <tr>
                                    <td style={{width: "40%"}}>Trainee Signature:</td><td >{record && record.trainee_sign}</td>
                                    <td style={{width: "15%"}}>&nbsp;Date:</td><td >{record && record.trainee_sign_date && moment(record.trainee_sign_date).format('MM/DD/yyyy') }</td>
                                </tr>
                                <tr>
                                    <td>Center Manager Signature:</td><td>{record && record.mgr_sign}</td>
                                    <td>&nbsp;Date:</td><td>{record && record.mgr_sign_date && moment(record.mgr_sign_date).format('MM/DD/yyyy') }</td>
                                </tr>
                                <tr>
                                    <td>Quality Assurance Signature:</td><td>{record && record.qa_sign}</td>
                                    <td>&nbsp;Date:</td><td>{record && record.qa_sign_date && moment(record.qa_sign_date).format('MM/DD/yyyy')}</td>
                                </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                    
                    </tbody>
                </table>
            </div>
            
        </div>
    )
  }
}

export default ChecklistPrint